module.exports = __webpack_public_path__ + "images/facebook@2x.png?6299aebc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/facebook@2x.png
// module id = 622
// module chunks = 7